jQuery(function ($) {

    if (jQuery("body").hasClass("page-template-caring-network")) {

        jQuery('.network_div').append('<h5 class="load-more">Load More</h5>');

        var button = jQuery('.network_div .load-more');
        var page = 2;
        var loading = false;
        var stop_ajax = false;
        var scrollHandling = {
            allow: true,
            reallow: function () {
                scrollHandling.allow = true;
            },
            delay: 400 //(milliseconds) adjust to the highest acceptable value
        };

        /**
         * [window scroll load products posts]
         *
         */
        jQuery(window).scroll(function () {

            if (!loading && scrollHandling.allow) {

                scrollHandling.allow = false;
                setTimeout(scrollHandling.reallow, scrollHandling.delay);

                var offset = jQuery(button).offset().top - jQuery(window).scrollTop();

                if (1200 > offset) {
                    loading = true;
                    var data = {
                        action: 'load_posts_by_ajax',
                        nonce: beloadmore.nonce,
                        page: page,
                        query: beloadmore.query,
                    };

                    if (!stop_ajax) {

                        stop_ajax = true;

                        setTimeout(function () {

                            jQuery.post(beloadmore.url, data, function (res) {

                                if (res.success) {

                                    jQuery('.network_div .add_network').append(res.data);
                                    jQuery('.network_div').append(button);

                                    page = page + 1;
                                    loading = false;

                                    if (res.data == "") {

                                        jQuery('.network_div .load-more').html('<h5>No more Products found</h5>');
                                        setTimeout(function () {
                                            jQuery('.network_div .load-more').fadeOut();
                                            jQuery('.network_div .load-more').html('');
                                        }, 3000);

                                        stop_ajax = false;

                                    }

                                } else {
                                    console.log(res);
                                }

                            }).fail(function (xhr, textStatus, e) {
                                // console.log(xhr.responseText);
                            });

                        }, 500);

                    } else {

                        jQuery('.network_div .load-more').html('<h5>No more Products found</h5>');
                        setTimeout(function () {
                            jQuery('.network_div .load-more').css('opacity', '0');
                            jQuery('.network_div .load-more').html('');
                        }, 3000);

                    }

                }
            }

        });


        /**
         * [On dropdown change load products]
         *
         */
        jQuery('#cat').change(function () {

            jQuery('html, body').animate({
                scrollTop: jQuery(".caring-page").offset().top
            }, 800);

            var data = {
                action: 'load_posts_dropdown_ajax',
                //page: page,
                nonce: beloadmore.nonce,
                query: beloadmore.query,
                cat_id: jQuery('#cat').val()
            };


            jQuery.post(beloadmore.url, data, function (res) {

                if (res.success) {

                    jQuery('.network_div  .add_network').html(res.data);
                    jQuery('.network_div ').append(button);

                    page = page + 1;
                    loading = false;

                    if (res.data == "") {

                        jQuery('.network_div  .load-more').html('<h5>No more Products found</h5>');
                        setTimeout(function () {
                            jQuery('.network_div  .load-more').css('opacity', '0');
                            jQuery('.network_div  .load-more').html('');
                        }, 3000);

                    }

                } else {
                    console.log('else');
                }

            }).fail(function (xhr, textStatus, e) {
                // console.log(xhr.responseText);
            });


        });
    }


});